import { Heading2, ListItem, OrderedList, Paragraph } from "../../../../src/common/Markdown";
import * as React from 'react';
export default {
  Heading2,
  ListItem,
  OrderedList,
  Paragraph,
  React
};